import axios from '@/libs/api.request'

export const getallopatrylist = (page, limit, key, dates, state) => {
  return axios.request({
    url: '/v1/allopatry/allopatry/',
    method: 'get',
    params: {
      key,
      dates,
      state,
      page,
      limit
    }
  })
}

export const operationallopatry = (data, meth) => {
  return axios.request({
    url: '/v1/allopatry/allopatry/',
    method: meth,
    data
  })
}
